import { Boxes, Network, Factory, Scale, ShieldCheck, FileCheck2 } from 'lucide-react';
import { Typography } from './Typography';
import styles from './BenefitCard.module.css';
const icons = [Boxes, Network, Factory, Scale, ShieldCheck, FileCheck2];
export function BenefitCard({
  title,
  description,
  index = 0,
}: {
  title: string;
  description: string;
  index?: number;
}) {
  const Icon = icons[index % icons.length];
  return (
    <article className={styles.card}>
      <Icon size={30} strokeWidth={1.2} aria-hidden />
      <Typography as="h3" variant="subheading">
        {title}
      </Typography>
      <Typography tone="muted">{description}</Typography>
    </article>
  );
}
